import Image from "next/image";

const CustomImage = ({
  src,
  width,
  height,
  fallback = "",
  alt,
  fetchPriority,
  loading,
  priority,
  ...rest
}) => {
  return (
    <Image
      src={src || fallback}
      width={width}
      height={height}
      alt={alt}
      fetchPriority={fetchPriority}
      priority={priority}
      loading={loading}
      {...rest}
    />
  );
};

export default CustomImage;
